// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eSDWz","cardContainer":"styles_cardContainer__iYj1W","card":"styles_card__R0dWL"};